export default "/images/zap.svg?266beaf136b6db26a96bb65a771bfec4";